import { Injectable } from '@angular/core';
import { ApiService } from './api';

import { TextAdvertisement } from '../model/textAdvertisement';

@Injectable()
export class NotificationService {
    constructor(private api: ApiService) { }

    async sendTexts(textAdvertisement: TextAdvertisement, emailToo: boolean, testNumber: string) {
        const url = `${this.api.endpoints.texting}/sendTexts?emailToo=${emailToo}&testNumber=${testNumber}`;
        return await this.api.postWithAuth(url, textAdvertisement);
    }

    async getTextingReach(textAdvertisement: TextAdvertisement) {
        const url = `${this.api.endpoints.texting}/getTextingReach`;
        return await this.api.postWithAuth(url, textAdvertisement);
    }

    async sendPushes(textAdvertisement: TextAdvertisement, accountId: string) {
        const url = `${this.api.endpoints.notification}/sendPushes?accountId=${accountId}`;
        return await this.api.postWithAuth(url, textAdvertisement);
    }

    async getPushReach(textAdvertisement: TextAdvertisement) {
        const url = `${this.api.endpoints.notification}/getPushReach`;
        return await this.api.postWithAuth(url, textAdvertisement);
    }
}



// WEBPACK FOOTER //
// ./src/services/texting.service.ts